/** Shared between the desktop SVG chart and the mobile list view, so Final Positions
 * always colors and scores a prediction the same way regardless of screen size. */

/** Accent color for a predicted-vs-actual error, from exact (green) to way off (red). */
export function errorColor(error: number): string {
  if (error === 0) return "oklch(0.65 0.2 145)";
  if (error <= 2) return "oklch(0.70 0.18 125)";
  if (error <= 5) return "oklch(0.72 0.18 90)";
  if (error <= 9) return "oklch(0.68 0.2 55)";
  return "oklch(0.60 0.22 25)";
}

/** Points for one club's prediction: base accuracy (N - error), plus the bullseye bonus
 * when the prediction is exact. Mirrors the backend's FINAL_POSITIONS scoring matrix —
 * see docs/GAME_MODES.md. */
export function calcPts(error: number, N: number, bonus: number): number {
  return N - error + (error === 0 ? bonus : 0);
}
